import axios from 'axios';

const ADMIN_TOKEN_KEY = 'admin_token';

export function getAdminToken() {
  try {
    return localStorage.getItem(ADMIN_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setAdminToken(token) {
  try {
    localStorage.setItem(ADMIN_TOKEN_KEY, token);
  } catch (e) {
    console.warn('无法保存 admin token:', e);
  }
}

export function clearAdminToken() {
  try {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch {}
}

const baseURL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : '');

const adminAxios = axios.create({ baseURL });

adminAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      clearAdminToken();
      if (typeof window !== 'undefined') {
        window.location.replace('/admin');
      }
    }
    return Promise.reject(err);
  }
);

export const adminRequest = (config) => {
  const token = getAdminToken();
  const headers = { ...config.headers };
  if (token) headers['x-admin-token'] = token;

  return adminAxios({ ...config, headers });
};
